/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ShopifyOrderDtoModel, ShopifyOrderDtoModelType } from "./ShopifyOrderDtoModel"
import { ShopifyOrderDtoModelSelector } from "./ShopifyOrderDtoModel.base"
import { ShopifyOrdersPageInfoDtoModel, ShopifyOrdersPageInfoDtoModelType } from "./ShopifyOrdersPageInfoDtoModel"
import { ShopifyOrdersPageInfoDtoModelSelector } from "./ShopifyOrdersPageInfoDtoModel.base"
import { RootStoreType } from "./index"


/**
 * ShopifyOrdersResultDtoBase
 * auto generated base class for the model ShopifyOrdersResultDtoModel.
 */
export const ShopifyOrdersResultDtoModelBase = ModelBase
  .named('ShopifyOrdersResultDto')
  .props({
    __typename: types.optional(types.literal("ShopifyOrdersResultDto"), "ShopifyOrdersResultDto"),
    orders: types.union(types.undefined, types.array(types.late((): any => ShopifyOrderDtoModel))),
    pageInfo: types.union(types.undefined, types.late((): any => ShopifyOrdersPageInfoDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShopifyOrdersResultDtoModelSelector extends QueryBuilder {
  orders(builder: string | ShopifyOrderDtoModelSelector | ((selector: ShopifyOrderDtoModelSelector) => ShopifyOrderDtoModelSelector) | undefined) { return this.__child(`orders`, ShopifyOrderDtoModelSelector, builder) }
  pageInfo(builder: string | ShopifyOrdersPageInfoDtoModelSelector | ((selector: ShopifyOrdersPageInfoDtoModelSelector) => ShopifyOrdersPageInfoDtoModelSelector) | undefined) { return this.__child(`pageInfo`, ShopifyOrdersPageInfoDtoModelSelector, builder) }
}
export function selectFromShopifyOrdersResultDto() {
  return new ShopifyOrdersResultDtoModelSelector()
}

export const shopifyOrdersResultDtoModelPrimitives = selectFromShopifyOrdersResultDto()
